import styled from "styled-components";
import { StoredImage } from "./StoredImage";
import { Trans } from "@coworker/locales";

const PreviewHeader = styled("div")`
  display: flex;
  flex-direction: row;
  width: 100%;
  box-sizing: border-box;
  justify-content: space-between;
  flex-shrink: 0px;
`;

const HeaderTitle = styled("div")`
  line-height: 21px;
  font-size: 14px;
  font-weight: bold;
  color: white;
`;

const HeaderButton = styled("button")`
  line-height: 21px;
  font-size: 14px;
  color: white;
  cursor: pointer;
  background: none;
  border: none;
`;

const ImagePreviewContainer = styled("div")`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const ImageHolder = styled("div")`
  margin-right: 9px;
  margin-bottom: 9px;
  overflow: hidden;
  display: inline-flex;
  vertical-align: top;
  width: 100%;
  height: 100%;
`;

function PreviewImage(props) {
  if (!props.image) {
    return null;
  }
  return (
    <>
      <PreviewHeader>
        <HeaderButton onClick={props.onClose}>
          <Trans>cancelString</Trans>
        </HeaderButton>
        <HeaderTitle>
          <Trans>imageString</Trans>
        </HeaderTitle>
        <HeaderButton onClick={props.onDelete}>
          <Trans>deleteString</Trans>
        </HeaderButton>
      </PreviewHeader>
      <ImagePreviewContainer>
        <ImageHolder>
          <StoredImage size="large" image={props.image} dark />
        </ImageHolder>
      </ImagePreviewContainer>
    </>
  );
}

export default PreviewImage;
